import BtSupervisionTableRow from './BtSupervisionTableRow';
import { FTableContainer } from '../../../base';
import { otherData, otherHeaderConfig } from './constants';

import type { IBtSupervision } from '../../../../utils/types';

interface OtherBtSupervisionProps {
  isEditable: boolean;
  btSupervision: IBtSupervision;
  onUpdateValue: (key: string, value: string) => void;
}

function OtherBtSupervision({ isEditable, btSupervision, onUpdateValue }: OtherBtSupervisionProps) {
  return (
    <FTableContainer
      sx={{ mt: 3, borderRadius: '0px 0px 4px 4px' }}
      headerStyle={{ borderRadius: '4px 4px 0px 0px', pl: 3, px: 0 }}
      headerConfig={otherHeaderConfig}
    >
      {otherData.map((item) => {
        return (
          <BtSupervisionTableRow
            key={item.id}
            value={item.label}
            headerConfig={otherHeaderConfig}
            isEditable={isEditable}
            selectedValue={{
              key: item.key,
              value: btSupervision[item.key],
            }}
            onChange={onUpdateValue}
          />
        );
      })}
    </FTableContainer>
  );
}

export default OtherBtSupervision;
